<div class="container-fluid" >
  <div class="row">
    <div class="col-md-12">
      <img alt="" width="900px" height="100px" [src]="'/assets/dspace/images/banner-repositorio.png'" class="img-fluid mx-auto d-block site_logo"/>
    </div>
  </div>
</div>


<!--<div class="container-fluid" >
  <div class="row">
    <div class="col-md-12">
      <img alt="" [src]="'/assets/dspace/images/01.jpg'" class="img-fluid mx-auto d-block"/>
      <img src="https://admision.espe.edu.ec/wp-content/uploads/2024/05/Admin.png" class="img-fluid mx-auto d-block">
    </div>
  </div>
</div>-->
